export default "__VITE_ASSET__CqGZB6f6__"